var _defs, _rect, _rect2, _path, _rect3, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryMinTotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.46 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:169.15px;font-family:Montserrat-Bold, Montserrat;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "deliveryMinTotal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 298.67,
    y: 160,
    width: 21.33,
    height: 21.33
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 21.33,
    height: 21.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,327.8,480,221.14a10.67,10.67,0,0,0-10.67-7.58H384v-64a21.33,21.33,0,0,0-21.33-21.33H320a128,128,0,0,0-256,0H21.33A21.33,21.33,0,0,0,0,149.56V480.23a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32v-32h85.33A10.67,10.67,0,0,0,480,440.66L512,334A10.7,10.7,0,0,0,512,327.8ZM192,21.56A106.67,106.67,0,0,1,298.67,128.23H85.33A106.67,106.67,0,0,1,192,21.56ZM362.67,480.23A10.67,10.67,0,0,1,352,490.9H32a10.67,10.67,0,0,1-10.67-10.67V149.56H362.67v64H117.33a32,32,0,0,0-32,32V416.23a32,32,0,0,0,32,32H362.67v32Zm98.77-53.33H117.33a10.67,10.67,0,0,1-10.66-10.67V245.56a10.66,10.66,0,0,1,10.66-10.66H461.44l29.23,96Z",
    transform: "translate(0 -0.23)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 444.44,
    y: 361.67,
    width: 21.33,
    height: 21.33
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(112.67 383)"
  }, "Min")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMinTotal);
export default __webpack_public_path__ + "static/media/deliveryMinTotal.f041a150ecb313ebb7550ebb32abe05f.svg";
export { ForwardRef as ReactComponent };